import { queryOptions } from "@tanstack/react-query";
import { t } from "../i18n/en";
import {
  getChartLibrarySession,
  getPrimaryChartForEmail,
  getSavedChartDetails,
  type SavedChartLibraryItem,
} from "./chart-library";
import {
  getFriendChartDetails,
  getFriendChartDetailsByUsername,
  getFriendsDashboard,
  getPublicChartDetailsByUsername,
} from "./friends-service";

export interface MeChartQueryData {
  ownerChart: (SavedChartLibraryItem & { isOwnerChart: true }) | null;
  error: string;
}

export const appQueryOptions = {
  meChart: () =>
    queryOptions({
      queryKey: ["charts", "me"] as const,
      queryFn: async (): Promise<MeChartQueryData> => {
        const session = getChartLibrarySession();
        if (!session) {
          return {
            ownerChart: null,
            error: t("ui.copy_sign_in_to_view_your_chart_acba71f9"),
          };
        }

        const ownerChart = await getPrimaryChartForEmail(session.email);
        if (!ownerChart) {
          return {
            ownerChart: null,
            error: t("ui.copy_your_primary_chart_is_not_available_83e55243"),
          };
        }

        return {
          ownerChart: { ...ownerChart, isOwnerChart: true },
          error: "",
        };
      },
      staleTime: 60_000,
    }),
  friendsDashboard: () =>
    queryOptions({
      queryKey: ["friends", "dashboard"] as const,
      queryFn: getFriendsDashboard,
      staleTime: 15_000,
    }),
  friendChart: (friendshipId: string) =>
    queryOptions({
      queryKey: ["friends", "chart", friendshipId] as const,
      queryFn: () => getFriendChartDetails(friendshipId),
      staleTime: 60_000,
    }),
  savedChart: (chartId: string) =>
    queryOptions({
      queryKey: ["charts", "saved", chartId] as const,
      queryFn: async () => {
        try {
          return await getSavedChartDetails(chartId);
        } catch {
          try {
            const friendChart = await getFriendChartDetailsByUsername(chartId);
            return { ...friendChart, isOwnerChart: false };
          } catch {
            const publicChart = await getPublicChartDetailsByUsername(chartId);
            return { ...publicChart, isOwnerChart: false };
          }
        }
      },
      staleTime: 60_000,
    }),
};
